import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import MainRouter from "./router/";
import { useDispatch } from "react-redux";
import { setCurrentUserAction } from "./redux/actions/loginActions";
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from "react-ga4";
import { getGATRackingId } from "./config";
import Loader from "./library/common/Loader";
import { isTokenExpired, refreshUserSession } from "./utils/helper";
const gaID = getGATRackingId();

function App() {
  const themeValue = localStorage.getItem("theme");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    ReactGA.initialize(gaID);

    const initAuth = async () => {
      const access_token = localStorage.getItem("access_token");
      const id_token = localStorage.getItem("id_token");

      if (access_token && id_token) {
        if (isTokenExpired(id_token)) {
          try {
            const refreshed = await refreshUserSession();
            if (refreshed?.idToken) {
              localStorage.setItem("id_token", refreshed.idToken);
              localStorage.setItem("access_token", refreshed.accessToken);
              dispatch(
                setCurrentUserAction({
                  idToken: refreshed.idToken,
                  accessToken: refreshed.accessToken,
                  tokenType: "id",
                })
              );
            } else {
              console.log("❌ Refresh failed on app load");
            }
          } catch (error) {
            console.log("❌ Refresh error on app load", error);
          }
        } else {
          dispatch(
            setCurrentUserAction({
              idToken: id_token,
              accessToken: access_token,
              tokenType: "id",
            })
          );
        }
      }
      setIsLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="App" data-theme={themeValue ? themeValue : "light"}>
      <Router>
        <MainRouter />
      </Router>
    </div>
  );
}

export default App;
